import { AccountTree, Bolt, Cable, CallMade, Functions, ThreeDRotation } from '@mui/icons-material';

export const IconServiceConnection = Cable;
export const IconIntegrationEvent = Bolt;
export const IconExpression = Functions;
export const IconOperation = CallMade;
export const IconSchema = AccountTree;
export const IconActivity = ThreeDRotation;
export const IconActivityTrigger = Bolt;
